// extracted by mini-css-extract-plugin
export var activeFilterButton = "_o1-c";
export var backButton = "_o1-4";
export var backIcon = "_o1-5";
export var chevronShortcut = "_o1-6";
export var container = "_o1-1";
export var editor = "_o1-8";
export var editorWrapper = "_o1-7";
export var prefix = "_o1-2";
export var searchIcon = "_o1-3";
export var suffix = "_o1-9";
export var suffixContent = "_o1-a";
export var suffixText = "_o1-b";
export var wrapper = "_o1-0";